import axiosIns from '@/plugins/axios'

export default {
  getMyAbilities() {
    return axiosIns.get('/v2/security/my_abilities')
  },
}
